import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { TranslationPackageLanguageBranchDeletionFormComponent } from './translation-package-language-branch-deletion-form.component';



@NgModule({
  declarations: [TranslationPackageLanguageBranchDeletionFormComponent],
  exports: [
    TranslationPackageLanguageBranchDeletionFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule
  ]
})
export class TranslationPackageLanguageBranchDeletionFormModule { }
